import { createCentrifugalSpinFrames } from "../../core/centrifugal-spin-keyframes.js";

export const meta = Object.freeze({
  id: "spin-centrifugal",
  label: "Zentrifugal-Drehung",
  duration: 1750,
  description: "Drei schnelle Drehungen um die Hochachse mit räumlich umlaufendem Gesicht und Speed Lines.",
  tags: ["body", "spin", "centrifugal", "speed-lines", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!scene?.speedLinesBack || !scene?.speedLinesFront) {
    throw new Error("Die Zentrifugal-Drehung benötigt beide räumlichen Speed-Line-Ebenen in der Stage.");
  }

  const frames = createCentrifugalSpinFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.shine, frames.shine, options),
    animate(elements.surfaceA, frames.surfaceA, options),
    animate(elements.surfaceB, frames.surfaceB, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.glow, frames.glow, options),
    animate(scene.speedLinesBack, frames.speedBack, options),
    animate(scene.speedLinesFront, frames.speedFront, options),
    ...scene.speedLinePathsBack.map((path) => animate(path, frames.speedStreaks, options)),
    ...scene.speedLinePathsFront.map((path) => animate(path, frames.speedStreaks.map((frame) => ({
      ...frame,
      strokeDashoffset: `${-Number.parseFloat(frame.strokeDashoffset)}px`,
    })), options)),
  ];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
